import moment from 'moment';
import Api from '../../../shared/Api';
import ICalendarItem from '../../calendar/Types';

export default class PhotographerCalendarApi {
    static getPhotographerCalendars(
        date: Date,
        orderId: number,
        regionId?: number,
        isAdvanceMode?: boolean,
        executionTime?: number,
        includeTraveltimes?: boolean
    ) {
        const momentDate = moment(date);
        let parameters = {
            regionId: regionId,
            isAdvanceMode: isAdvanceMode,
            includeTraveltimes: includeTraveltimes,
            year: null,
            month: null,
            day: null,
            hours: null,
            minutes: null,
            executionTime: executionTime
        };

        if (date) {
            parameters.year = momentDate.year();
            parameters.month = momentDate.month() + 1;
            parameters.day = momentDate.date();
        }

        return new Api().get(`/views/photographer-booking/se360/${orderId}`, parameters);
    }

    static getBookingInfo(date: Date, orderId: any) {
        const momentDate = moment(date);
        let parameters = {
            year: null,
            month: null,
            day: null
        };

        if (date) {
            parameters.year = momentDate.year();
            parameters.month = momentDate.month() + 1;
            parameters.day = momentDate.date();
        }
        return new Api().get(
            `/views/photographer-booking/se360/get-booking-info/${orderId}`,
            parameters
        );
    }

    static updatePhotographerCalendar(data: {
        calendarItem: ICalendarItem;
        planOrderId: number | null;
        isAdvanced: boolean;
    }) {
        return new Api().put(`/views/photographer-booking`, data);
    }

    static getLocationData(date: string, orderid?: number, lat?: number, lon?: number) {
        return new Api().get(`/views/photographer-booking/location`, {
            date: date,
            lat: lat && lat.toString(),
            lon: lon && lon.toString(),
            orderId: orderid
        });
    }

    static getphotographersForNewBooking(
        date: Date,
        address: string,
        postalCode: string,
        city: string,
        executionTime: number,
        productIds: number[],
        brokerFirmId: number,
        numberOfMeasuredPlans?: number,
        lat?: number,
        lon?: number
    ) {
        const momentDate = moment(date);
        let parameters = {
            year: momentDate.year(),
            month: momentDate.month() + 1,
            day: momentDate.date(),
            hours: momentDate.hours(),
            minutes: momentDate.minutes(),
            address: address,
            postalCode: postalCode,
            city: city,
            executionTime: executionTime,
            productIds: productIds,
            brokerFirmId: brokerFirmId,
            numberOfMeasuredPlans: numberOfMeasuredPlans,
            lat: lat,
            lon: lon
        };
        return new Api().get('/views/photographer-booking/se360/', parameters);
    }

    static getPhotographersForNewDuskBooking(
        date: Date,
        address: string,
        postalCode: string,
        city: string,
        executionTime: number,
        productIds: number[],
        brokerFirmId: number,
        numberOfMeasuredPlans?: number,
        lat?: number,
        lon?: number
    ) {
        const momentDate = moment(date);
        let parameters = {
            year: momentDate.year(),
            month: momentDate.month() + 1,
            day: momentDate.date(),
            hours: momentDate.hours(),
            minutes: momentDate.minutes(),
            address: address,
            postalCode: postalCode,
            city: city,
            executionTime: executionTime,
            productIds: productIds,
            brokerFirmId: brokerFirmId,
            numberOfMeasuredPlans: numberOfMeasuredPlans,
            lat: lat,
            lon: lon
        };
        return new Api().get('/views/photographer-booking/se360/dusk/', parameters);
    }
    
    static getPhotographersForDuskRebooking(
      date: Date,
      orderId: number,
      executionTime?: number,
    ) {
        const momentDate = moment(date);
        let parameters = {
            isAdvanceMode: false,
            includeTraveltimes: true,
            year: null,
            month: null,
            day: null,
            hours: null,
            minutes: null,
            executionTime: executionTime
        };

        if (date) {
            parameters.year = momentDate.year();
            parameters.month = momentDate.month() + 1;
            parameters.day = momentDate.date();
        }

        return new Api().get(`/views/photographer-booking/se360/dusk/${orderId}`, parameters);
    }

    static getAddressCoordinates(address: string, postalCode: string, city: string) {
        return new Api().get(
            `/views/photographer-booking/getaddresscoordinates?address=${address}&postalCode=${postalCode}&city=${city}`
        );
    }
}
